import { zh } from '../../utils/zh';
import { Outlet } from 'react-router-dom';
import { Sidebar } from './Sidebar';
import { AccountSwitcher, DomainConfig, SenderAccount } from './AccountSwitcher';
import { ComposeModal } from '../inbox/ComposeModal';

interface LayoutProps {
    accounts: DomainConfig[];
    selectedAccount: SenderAccount | null;
    onSelectAccount: (s: SenderAccount) => void;
    unreadCount: number;
    composeOpen: boolean;
    onComposeOpen: () => void;
    onComposeClose: () => void;
    authLabel?: string;
    onLogout?: () => void;
    previewMode?: boolean;
}

export function Layout({
    accounts,
    selectedAccount,
    onSelectAccount,
    unreadCount,
    composeOpen,
    onComposeOpen,
    onComposeClose,
    authLabel,
    onLogout,
    previewMode = false,
}: LayoutProps) {
    return (
        <div className="app-layout">
            <Sidebar unreadCount={unreadCount} previewMode={previewMode} />

            <div className="app-main">
                <header className="app-header">
                    <button className="btn btn-primary" onClick={onComposeOpen} disabled={previewMode} title={previewMode ? "本地预览暂不支持此操作" : undefined}>
                        ✉️ {previewMode ? "预览模式" : "写邮件"}
                    </button>

                    {previewMode ? (
                        <span className="local-preview-context">🇸🇦 沙特／中东示例预览</span>
                    ) : (
                        <AccountSwitcher
                            accounts={accounts}
                            selected={selectedAccount}
                            onSelect={onSelectAccount}
                        />
                    )}

                    {/* Auth info + Logout */}
                    {authLabel && (
                        <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginLeft: 'auto' }}>
                            <span style={{
                                padding: '4px 10px',
                                background: 'rgba(99, 102, 241, 0.15)',
                                border: '1px solid rgba(99, 102, 241, 0.3)',
                                borderRadius: 6,
                                fontSize: 11,
                                fontWeight: 600,
                                color: '#a5b4fc',
                            }}>
                                🔐 {zh(authLabel)}
                            </span>
                            {onLogout && !previewMode && (
                                <button
                                    onClick={onLogout}
                                    style={{
                                        padding: '4px 10px',
                                        background: 'rgba(239, 68, 68, 0.1)',
                                        border: '1px solid rgba(239, 68, 68, 0.3)',
                                        borderRadius: 6,
                                        fontSize: 11,
                                        fontWeight: 600,
                                        color: '#f87171',
                                        cursor: 'pointer',
                                    }}
                                >
                                    退出登录
                                </button>
                            )}
                        </div>
                    )}
                </header>

                <main className="app-content">
                    <Outlet />
                </main>
            </div>

            {composeOpen && !previewMode && (
                <ComposeModal
                    accounts={accounts}
                    defaultSender={selectedAccount}
                    onClose={onComposeClose}
                />
            )}
        </div>
    );
}
